<template>
  <div class="com-dimensional-box">
    <template v-for="item in list">
      <!-- 任务模型 -->
      <template v-if="item.rangeType === 5 && isForm">
        <rt-model ref="rtModel" :key="item.id" :type="item.itemType" :rtDetails="rtModelDetail" :defaultCheckedKeys="checkedKeys" @changeChecks="getCheckList"></rt-model>
      </template>
      <!-- 能力模型 -->
      <template v-else-if="item.rangeType === 4 && isForm">
        <skill-model :key="item.id" :isForm="isForm" :type="item.itemType" :jqDetails="skillModelDetail" :defaultCheckedKeys="defaultCheckedKeys"></skill-model>
      </template>
      <template v-else-if="item.rangeType === 3 && (isForm && !item.ruleId) || (!isForm && item.ruleId)">
        <yxt-checkbox
          v-model="item.checked"
          :key="item.id"
          :label="item.id"
          :disabled="defaultCheckedKeys.includes(item.id)"
          class="mb8"
        >
          <yxt-popover placement="bottom" trigger="hover" :max-width="960">
            <!-- <div>
              <h3>任务</h3>
              <p>任务描述：展示维护任务的描述信息内容，描</p>
            </div> -->
            <talent-dimension-detail v-if="item.show && item.ruleId" :key="item.id" :ruleId="item.ruleId"></talent-dimension-detail>
            <div slot="reference" class="com-dimensional-box__text" @mouseenter.self="show(item)">
              {{ item.itemValue }}
            </div>
          </yxt-popover>
        </yxt-checkbox>
      </template>
    </template>
  </div>
</template>

<script>
import skillModel from './skill-model';
import rtModel from './rt-model';

export default {
  components: { skillModel, rtModel },
  props: {
    isForm: Boolean,
    list: {
      type: Array,
      default: () => []
    },
    rtModelDetail: { // 任务模型详情
      type: Object,
      default: () => { }
    },
    skillModelDetail: { // 能力模型详情
      type: Object,
      default: () => { }
    },
    defaultCheckedKeys: { // 默认置灰不可选
      type: Array,
      default: () => []
    },
    checkedKeys: { // 任务模型默认选中
      type: Array,
      default: () => []
    }
  },
  methods: {
    getCheckList(data) {
      this.$emit('update:checkedKeys', data);
    },
    show(item) {
      this.$set(item, 'show', true);
    }
  }
};
</script>

<style lang="scss" scoped>
  .com-dimensional-box {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    .yxt-tree-node__labelGroup {
      display: flex;
      align-items: center;
    }
    &__text {
      font-size: 14px;
      font-weight: 400;
      color: #595959;
      line-height: 22px;
    }
  }
</style>